import React, { FC, Fragment, useState } from 'react';
// types
import { IOpportunityResponse } from '@joc/api-gateway';
// styles
import { connect, ConnectedProps } from 'react-redux';
import { Store } from 'redux/root';
// import { selectorGetOrgId } from 'redux/organization-service/selector';
import { resetError, setError } from 'redux/error-service/action';
import { selectorGetError } from 'redux/error-service/selector';
import ResponseFailure from 'shared/components/ResponseFailure';
import { createOpportunity, getOpportunitiesCount } from 'redux/opportunities-service/action';
import PopupUpdate from '../PopupUpdate';
import PopupCongrats from '../PopupCongrats';

type PopupCreateParentProps = {
	setIsShowPopup: React.Dispatch<React.SetStateAction<boolean>>;
	isSmartGroupMode?: boolean;
};

const PopupCreate: FC<PopupCreateProps> = ({ setIsShowPopup, error }: PopupCreateProps) => {
	const [isSubmited, setIsSubmited] = useState(false);
	const [isShowUpdatePopup, setIsShowUpdatePopup] = useState(false);
	const [createdOpportunityData, setCreatedOpportunityData] = useState<IOpportunityResponse>();

	const createOneMoreClickHandler = () => {
		setIsSubmited(false);
	};

	if (error.state)
		return (
			<ResponseFailure
				styleTable
				message={error.message ? error.message : 'Something went wrong. Please try again'}
				buttonClickHandler={() => {
					resetError();
				}}
				buttonTitle="Check and try again"
			/>
		);
	if (isSubmited)
		return (
			<PopupCongrats
				setIsShowPopup={setIsShowPopup}
				setIsSubmited={setIsSubmited}
				setIsShowUpdatePopup={setIsShowUpdatePopup}
				createOneMoreClickHandler={createOneMoreClickHandler}
			/>
		);
	if (isShowUpdatePopup && createdOpportunityData)
		return (
			<PopupUpdate
				setIsShowUpdateOpportunityPopup={setIsShowUpdatePopup}
				opportunityData={createdOpportunityData}
			/>
		);
	return (
		<Fragment>
			<h2 className="title">Create a new Opportunity</h2>
			{/* <OpportunityForm isLoading={isLoading} initialValues={formValues} submitClickHandler={submitClickHandler} /> */}
		</Fragment>
	);
};

const mapStateToProps = (store: Store) => ({
	error: selectorGetError(store),
});

const mapDispatchToProps = {
	createOpportunity,
	getOpportunitiesCount,
	setError,
	resetError,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PopupCreateProps = ConnectedProps<typeof connector> & PopupCreateParentProps;

export default connector(PopupCreate);
